import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-key" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "modal-dialog" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary btn-sm",
  "data-bs-dismiss": "modal"
}, " Avbryt ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_field_errors = _resolveComponent("field-errors")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showResetPassword(_ctx.account))),
      class: "btn btn-sm btn-primary",
      "data-toggle": "modal",
      "data-target": "#resetPasswordModal",
      title: "Ändra lösenord"
    }, _hoisted_2),
    _createElementVNode("div", {
      class: "modal fade",
      id: 'pwr_' + _ctx.state.userAccount.userId,
      tabindex: "-1",
      "aria-labelledby": "staticBackdropLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, " Återställ lösenord för " + _toDisplayString(_ctx.state.userAccount.email), 1),
            _hoisted_8
          ]),
          (_ctx.state.changePasswordRequest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_text_field, {
                      label: "Lösenord",
                      modelValue: _ctx.state.changePasswordRequest.newPassword,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.changePasswordRequest.newPassword) = $event)),
                      onInput: _ctx.validatePasswordRequest
                    }, null, 8, ["modelValue", "onInput"]),
                    _createVNode(_component_field_errors, {
                      errors: _ctx.state.changePasswordErrors,
                      field: "newPassword"
                    }, null, 8, ["errors"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_text_field, {
                      label: "Lösenord",
                      modelValue: _ctx.state.changePasswordRequest.newPasswordVerifikation,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.changePasswordRequest.newPasswordVerifikation) = $event)),
                      onInput: _ctx.validatePasswordRequest
                    }, null, 8, ["modelValue", "onInput"]),
                    _createVNode(_component_field_errors, {
                      errors: _ctx.state.changePasswordErrors,
                      field: "newPasswordVerifikation"
                    }, null, 8, ["errors"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-secondary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setGeneratedPassword && _ctx.setGeneratedPassword(...args)))
                    }, " Generera lösenord ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
            }, " Byt lösenord ")
          ])
        ])
      ])
    ], 8, _hoisted_3)
  ]))
}